__turbopack_context__.v({
  "questionnaireResponsiveNavigation": "QuestionnaireResponsiveNavigation-module__h5LCUa__questionnaireResponsiveNavigation",
});
